import { variables } from './common/variables';

import {
  cl,
  dmsToLonLat,
  urlMapsSelector,
  sortArray,
  convertLong,
  convertLat,
  trimToLowerCase,
  makeScrollbar,
  ajax,
  makeSVGGradient
} from './common/functions';

import { map, markersCluster } from './components/leaflet/leaflet__map-init';
import { makeMarkerIcon } from './components/leaflet/markerIcon';
import { search } from './components/search';
import { createFilters } from './components/filters';
import { loader } from './components/loader';
import { geolocation } from './components/geolocation';
import { resetLocation } from './components/resetLocation';
import { listEvent, markerEvent, markerClusterEvents } from './components/events';

if (document.getElementById("map")) {
  if (!!variables) {
    if (variables.shortcodeTypeValue) {
      /*------------ [AJAX] success------------*/
      const success = data => {
        /*------------ [MAIN DATAS] ------------*/
        cl(data);
        const types = data.types;
        const entities = data.entities;
        if (types && entities) {
          const storesContainer = document.getElementById('stores__container');
          //clear des markers
          const markersLayer = new L.LayerGroup();
          markersLayer.clearLayers();

          /*------------ [LOADER] ------------*/
          loader();

          //sort par ordre alphabetique
          sortArray(entities);

          variables.shortcodeTypeValue = trimToLowerCase(variables.shortcodeTypeValue);
          const categoryArray = [];
          if (variables.shortcodeTemplateValue !== 'full') {
            !!types.length && [...types].forEach(type => {
              if (variables.shortcodeTypeValue.split(",").includes(trimToLowerCase(type.types_name))) {
                categoryArray.indexOf(type.categories_name) === -1 ? categoryArray.push(type.categories_name) : null;
              }
            });
          }

          [...entities].forEach(entity => {
            //json datas
            let { id, name, latitude: lat, longitude: long, type, color, category, address, website, phone, schedule, fullSchedule, permalink } = entity;
            color = !!color.length ? color : '';
            category = !!category.length ? category : '';
            address = !!address ? address : '';
            website = !!website ? website : '';
            phone = !!phone ? phone : '';
            schedule = !!schedule ? schedule : '';
            fullSchedule = !!fullSchedule ? fullSchedule : '';
            permalink = !!permalink ? permalink : '';


            // Creation du gradient
            let bgColor = "";
            if (color === "") {
              bgColor = `linear-gradient(to right, ${variables.primaryColor}, ${variables.primaryColor})`;
            } else {
              bgColor = `linear-gradient(to right,`;
              if (!!color.length) {
                if (color.length === 1) {
                  bgColor += `${color[0]}, ${color[0]}`
                } else {
                  for (let i = 0; i < color.length; i++) {
                    if (i === color.length - 1) {
                      bgColor += `${color[i]}`;
                    } else {
                      bgColor += `${color[i]}, `;
                    }
                  }
                }
              }
              bgColor += `)`;
            }

            if (variables.shortcodeTemplateValue !== 'full' && !!category[0] && categoryArray.includes(category[0]) || !!type.length) {
              // Array clean avec les types
              //remplissage des array
              const typesTrimmedArray = [];
              type.forEach(element => {
                const trimmedElement = trimToLowerCase(element);
                typesTrimmedArray.push(trimmedElement);
                variables.arrayTypes.push(trimmedElement);
              });
              category.forEach(element => {
                const trimmedElement = trimToLowerCase(element);
                variables.arrayCategories.indexOf(trimmedElement) === -1 ? variables.arrayCategories.push(trimmedElement) : null;
              });

              if (
                variables.shortcodeTypeValue.split(",").some(ai => typesTrimmedArray.includes(ai))
                || variables.shortcodeTypeValue.includes('all')
              ) {
                //traitement des coordonnées
                if (!!long && !!lat) {
                  //traitement des coordonées
                  const latitude = dmsToLonLat(convertLat(lat).lat);
                  const longitude = dmsToLonLat(convertLong(long).long);

                  const fullScheduleClosed = Object.keys(fullSchedule).every((k) => { return fullSchedule[k] === 'Fermé' });

                  //creation du marker
                  const marker = L.marker([latitude, longitude], {
                    tags: typesTrimmedArray, //pour les filtres
                    permalink: permalink, // pour les fancyboxes
                    name: name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), // pour la recherche
                    icon: makeMarkerIcon(id, typesTrimmedArray, [...color], null, null),
                    markerId: `${id}`
                  })

                  //append des markers à un groupe puis sur la carte
                  variables.markers.push(marker);
                  markersCluster.addLayer(marker);
                  map.addLayer(markersCluster);
                  variables.group = new L.featureGroup(variables.markers);
                  map.fitBounds(variables.group.getBounds().pad(0));

                  if (variables.shortcodeTemplateValue === 'full') {
                    // Affichage de l'adresse
                    const addressText = !!address ? /* html */ `
                    <a class="text__address" target="_blank" href="${urlMapsSelector(latitude, longitude)}">
                      <svg version="1.1" xmlns:serif="http://www.serif.com/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 40 40"
                        style="enable-background:new 0 0 40 40;" xml:space="preserve">
                        <defs>
                          <linearGradient id="leaflet-marker-gradient__${id + 100}">
                              ${makeSVGGradient(color)}
                          </linearGradient>
                        </defs>
                        <path fill="url(#leaflet-marker-gradient__${id + 100})" class="st0" d="M20,2.6c-7.2,0-13.3,5.8-13.3,13.3c0,3,2.1,7.4,6,13c3,4,6,7.2,6,7.4l1.2,1.2l1.2-1.2c0.2-0.2,3-3.3,6-7.4 c4.2-5.6,6-10,6-13C33.3,8.4,27.2,2.6,20,2.6z M20,20.5c-2.6,0-4.9-2.1-4.9-4.9s2.1-4.9,4.9-4.9s4.9,2.1,4.9,4.9S22.6,20.5,20,20.5z"/>
                      </svg>
                      ${address}
                    </a>` : '';

                    // Affichage du siteweb
                    const websiteText = !!website ? `<a class="text__website" href="${website}" target="_blank">Site internet</a>` : '';

                    // Affichage du numéro de téléphone
                    const phoneText = !!phone ? `<a href="tel:${phone}" class="text__phone">${phone}</a>` : '';

                    const contentStoreContainer = `<div class="container__item ${typesTrimmedArray.join(' ')}" style="--markerColor:${bgColor};" id="item-${id}" data-display="true" data-marker="${id}">
                          <div class="item__text">
                            <div class="item__text--column">
                              <div class="text__crosshairs">
                                <h3 class="text__title">${name}</h3>
                              </div>
                              ${addressText}
                            </div>
                            <div class="item__text--column">
                              ${websiteText}
                              ${phoneText}
                            </div>
                          </div>
                        </div>`;
                    storesContainer.insertAdjacentHTML('beforeend', contentStoreContainer);

                    /*------------ [EVENT] Liste ------------*/
                    listEvent(map, marker, id, fullSchedule, variables.markers, markersCluster);
                  }
                }
              }
            }
          });

          /*------------ [EVENT] Marker Cluster ------------*/
          markerClusterEvents(variables.markers, markersCluster);

          /*------------ [EVENT] Marker ------------*/
          markerEvent(map, markersCluster);

          /*------------ [GEOLOCATION] ------------*/
          if (variables.shortcodeGeolocalisationValue === 'true') {
            geolocation(map, variables.group);
          }
          /*------------ [RESET LOCATION] ------------*/
          resetLocation(map, variables.group);

          if (variables.shortcodeTemplateValue === 'full') {
            if (variables.shortcodeFiltersValue === 'true') {
              const paramsTypes = variables.params.type;
              let paramsTypesArray = [];
              if (!!paramsTypes) {
                paramsTypesArray = paramsTypes.split(",");
                if (
                  !!paramsTypesArray.length
                  && paramsTypesArray.length > 1
                  || !!paramsTypesArray.length
                  && paramsTypesArray.includes('all')
                ) {
                  /*------------ [FILTERS] Create ------------*/
                  createFilters(variables.arrayTypes, variables.arrayCategories, variables.group, types);
                }
              }
            }

            /*------------ [OVERLAYSCROLLBAR] ------------*/
            makeScrollbar(storesContainer, "os-theme-dark", true);

            /*------------ [SEARCH] append & events  ------------*/
            search(variables.markers, markersCluster, map);
          }
        } else {
          const container = document.querySelector(".bootstrap-scope");
          if (!!container) {
            const loader = document.getElementById("map-container__loader");
            if (loader) {
              container.innerHTML = /*html*/ `
                <div class="container-fluid bg-light border no-data__wrapper">
                  ${loader.outerHTML}
                  <div class="row no-gutters">
                    <div class="col">
                        <p class="text-center">Aucune donnée renseignée pour la carte</p>
                    </div>
                  </div>
                </div>
              `;
            }
          }
        }
      };

      /*------------ [AJAX] error ------------*/
      const error = err => { cl(err) };

      /*------------ [AJAX] ------------*/
      ajax(variables.params, success, error, 'json');

      /*------------Template onlyMap Exception------------*/
      if (variables.shortcodeTemplateValue !== 'full') {
        const removeElement = id => {
          const element = document.getElementById(id);
          if (element) {
            element.remove();
          }
        };
        removeElement('map__stores');
        removeElement('searchTab');
        if (variables.mapContainer) {
          variables.mapContainer.classList.remove('col-md-7');
          variables.mapContainer.classList.remove('col-lg-8');
          variables.mapContainer.classList.remove('col-xl-9');
        }
      }

    }
  }
}
